import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';

/**
 * Confirmation modal for un-RSVPing / leaving an event when the user still
 * has queue entries or group memberships tied to it.
 *
 * Props:
 *   isOpen           - boolean
 *   onClose          - () => void  (cancel)
 *   onConfirm        - () => void  — proceed with Leave Event
 *   groups           - list of `{ group_id, groups: { name } }` (same shape as legacy)
 *   hasQueueEntry    - boolean — show queue-only messaging when no groups
 */
export default function UnRsvpConfirm({
  isOpen,
  onClose,
  onConfirm,
  groups = [],
  hasQueueEntry = false,
}) {
  // Reached by tapping "Going" again, so the title says what that tap does, and the body is one sentence
  // (operator, 2026-10-04: "Are you sure?" didn't say what the button was).
  const names = groups.map((g) => g.groups?.name).filter(Boolean);
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Leave this event?" size="md">
      <ModalBody>
        <p className="mb-2 text-ink/70" style={{ textWrap: 'pretty' }}>
          {names.length > 0 ? (
            <>
              This removes you from{' '}
              {names.map((name, i) => (
                <span key={name + i}>
                  {i > 0 && (i === names.length - 1 ? ' and ' : ', ')}
                  {/* A name never splits across lines, and the full stop stays with the last one. */}
                  <span className="inline-block max-w-full">
                    <strong className="font-semibold text-ink">{name}</strong>
                    {i === names.length - 1 ? '.' : ''}
                  </span>
                </span>
              ))}
            </>
          ) : hasQueueEntry ? (
            'This removes you from group matching.'
          ) : (
            'This removes you from the going list.'
          )}
        </p>
      </ModalBody>
      <ModalFooter align="right">
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="destructive" onClick={onConfirm}>
          Leave Event
        </Button>
      </ModalFooter>
    </Modal>
  );
}
